window.currencyFormatter = function(money_value, currency) {
  money_value = money_value/100;
  var converted_price = 0.0;
  currency == "EUR"
    ? (converted_price = Math.ceil(money_value * 1.0))
    : (converted_price = Math.ceil(money_value * getConversionRate()));
  
  return applyCurrencySymbol(
    formatConvertion(converted_price, currency),
    currency
  );
};

var getConversionRate = function() {
  return Shopify.currency.rate * 0.985;
};

var getCurrencySymbol = function(currency) {
  var symbols = {
    AUD: "$",
    CAD: "$",
    DKK: "kr",
    EUR: "€",
    HKD: "₹",
    JPY: "¥",
    NZD: "$",
    GBP: "£",
    SGD: "$",
    SEK: "kr",
    USD: "$"
  };

  return symbols[currency];
};

var formatConvertion = function(price, currency) {
  var number_formatted = "";
  var price_length = price.toString().length;
  var separators = getCurrencySeparators(currency);
  if (price_length < 4) {
    number_formatted = price;
  } else {
    
    for (var pos = price_length - 1; pos > 2; pos -= 3) {
      number_formatted =
        separators["sep_int"] +
        price.toString().substring((pos-2), pos+1) + 
        number_formatted;    
    }
    number_formatted = price.toString().substring(0, pos+1) + "" + number_formatted;
  }
  return number_formatted;
};

var getCurrencySeparators = function(cur) {
  if (
    cur == "AUD" ||
    cur == "CAD" ||
    cur == "EUR" ||
    cur == "HKD" ||
    cur == "JPY" ||
    cur == "NZD" ||
    cur == "GBP" ||
    cur == "SGD" ||
    cur == "USD"
  )
    return { sep_int: ",", sep_float: "." };
  else return { sep_int: ".", sep_float: "," };
};

var applyCurrencySymbol = function(money, currency) {
  var separators = getCurrencySeparators(currency);
  switch (currency) {
    case "AUD":
      return (
        getCurrencySymbol(currency) + money + separators["sep_float"] + "00"
      );
      break;
    case "CAD":
      return (
        getCurrencySymbol(currency) + money + separators["sep_float"] + "00"
      );
      break;
    case "DKK":
      return (
         money + separators["sep_float"] + "00" + getCurrencySymbol(currency)
      );
      break;
    case "EUR":
      return (
        getCurrencySymbol(currency) + money + separators["sep_float"] + "00"
      );
      break;
    case "HKD":
      return (
        getCurrencySymbol(currency) + money + separators["sep_float"] + "00"
      );
      break;
    case "JPY":
      return (
        getCurrencySymbol(currency) + money 
      );
      break;
    case "NZD":
      return (
        money + separators["sep_float"] + "00" + getCurrencySymbol(currency)
      );
      break;
    case "GBP":
      return (
        getCurrencySymbol(currency) + money + separators["sep_float"] + "00"  
      );
      break;
    case "SGD":
      return (
        money + separators["sep_float"] + "00" + getCurrencySymbol(currency)
      );
      break;
    case "SEK":
      return (
        money + getCurrencySymbol(currency)
      );
      break;
    case "USD":
      return (
        getCurrencySymbol(currency) + money + separators["sep_float"] + "00"
      );
      break;
    default:
    // code block
  }
};

window.Currency = {};
window.Currency.moneyFormats = {
    USD: {money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD"},
    EUR: {money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR"},
    AUD: {money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD"},
    CAD: {money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD"},
    DKK: {money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}"},
    HKD: {money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}"},
    JPY: {money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"},
    NZD: {money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD"},
    GBP: {money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP"},
    SGD: {money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD"},
    SEK: {money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK"}
  };


$(document).ready(function(){

  $(".converted_rb").each(function(index){
  	$(this).prepend("<span class='money'>"+ window.currencyFormatter($(this).attr("data-discounted-price"), Shopify.currency.active) +"</span>");
  });
  
  
  /*$(".show-more-btn").on("click", function(){
    $(".converted_rb").each(function(index){
    if( $(this).find("> span.money").length){
     	 
    } else {
  		$(this).prepend("<span class='money'>"+ window.currencyFormatter($(this).attr("data-discounted-price"), Shopify.currency.active) +"</span>");
    }
  	});                   
  });*/
});


